import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/management/add.svg'
import _imports_1 from '@/assets/img/management/trash.svg'


const _hoisted_1 = { class: "d-flex flex-wrap" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = { class: "fs_14 spaceCadet ms-2" }

export function render(_ctx: any,_cache: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mt-2 mb-2",
      localizedKey: "app_selezionaUnaCategoria",
      text: "Seleziona una categoria"
    }),
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (item, i) => {
        return (_openBlock(), _createBlock("div", {
          class: ["filterTab", { active: _ctx.$store.state.createEventVm.category == item.name }],
          key: i,
          onClick: ($event: any) => (_ctx.$store.state.createEventVm.category = item.name)
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_12 d-block",
            localizedKey: 'app_' + item.name,
            text: item.name
          }, null, 8, ["localizedKey", "text"])
        ], 10, ["onClick"]))
      }), 128))
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mt-3 mb-2",
      localizedKey: "app_inseriscifinoatretag",
      text: "Inserisci fino a 3 tag"
    }),
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        type: "text",
        autocomplete: "off",
        class: "genericInput littleHeight squareInput w-100",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newTag = $event)),
        disabled: _ctx.$store.state.createEventVm.tags.length >= 3,
        ref: "tagInput"
      }, null, 8, ["disabled"]), [
        [_vModelText, _ctx.newTag]
      ]),
      _createVNode("div", {
        class: "managementButton",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addTag())),
        disabled: _ctx.$store.state.createEventVm.tags.length >= 3 || !_ctx.newTag
      }, [
        _hoisted_3
      ], 8, ["disabled"])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.createEventVm.tags, (item, i) => {
      return (_openBlock(), _createBlock("div", {
        class: "d-flex align-items-center mt-2",
        key: i,
        onClick: ($event: any) => (_ctx.removeTag(i))
      }, [
        _hoisted_4,
        _createVNode("span", _hoisted_5, _toDisplayString(item), 1)
      ], 8, ["onClick"]))
    }), 128))
  ]))
}